<template>
  <v-app class="pay">
    <v-layout wrap justify-center>
      <v-flex xs12 text-center align-self-center>
        <vue-element-loading
          :active="appLoading"
          color="#68D389"
          spinner="bar-fade-scale"
        >
        </vue-element-loading>
        <span style="font-size: 18px">
          Please don't go back or refresh the page, while we redirect you
        </span>
      </v-flex>
    </v-layout>
  </v-app>
</template>
<script>
import axios from "axios";
export default {
  props: ["paymentId", "orderid"],
  data() {
    return {
      appLoading: false,
    };
  },
  created() {
    this.paymentStatus();
  },
  methods: {
    paymentStatus() {
       this.appLoading= true
      axios({
        method: "POST",
        url: "/order/razorpay/checkstatus",
        data: {
          id: this.paymentId,
          order_id: this.orderid,
        },
      })
        .then((response) => {
          var PaymentData = null;
          PaymentData = response.data.data;
          this.appLoading= false;
          if (PaymentData.paymentStatus === "Success") {
            location.href = "/orders?type=Active/";
          } else if (PaymentData.paymentStatus === "Failure") {
            location.href = "cart/";
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
  },
};
</script>
<style>
.pay {
  min-height: 100vh;
  min-width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  background-color: white;
  overflow-x: hidden;
}
</style>